module.exports = __webpack_public_path__ + "img/image6.a181aa6a.png";